import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaHotel, FaMapMarkerAlt, FaStar, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import hotelBg from "../../Assets/img/hotel_cat.png";
import CategoryBookingPopup from "../../components/common/CategoryBookingPopup";

// Import Local Assets
import img1 from "../../Assets/img/h2.png";
import img2 from "../../Assets/img/h1.png";
import img3 from "../../Assets/img/h3.png";
import img4 from "../../Assets/img/h4.png";
import img5 from "../../Assets/img/h5.png";
import img7 from "../../Assets/img/h6.png";
import img9 from "../../Assets/img/h7.png";
import img11 from "../../Assets/img/h8.png";


const Hotels = () => {
  const navigate = useNavigate();
  const [popupData, setPopupData] = useState({ isOpen: false, itemName: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    document.title = " Hotels | Khajuraho Routes";
    window.scrollTo(0, 0);
  }, []);

const hotels = [
  {
    id: 1,
    name: "Radisson Jass",
    location: "By Pass Road, Khajuraho, Madhya Pradesh 471606",
    desc: "Premium 5-star resort offering world-class amenities, spa, and serene temple surroundings.",
    img: img1,
    star: "5 Star"
  },
  {
    id: 2,
    name: "The Lalit Temple View",
    location: "Opposite Circuit House, Sevagram, Khajuraho, Madhya Pradesh 471606",
    desc: "Ultra-luxury stay located near the Western Group of Temples with stunning heritage views.",
    img: img2,
    star: "5 Star"
  },
  {
    id: 3,
    name: "Ramada by Wyndham ",
    location: "Airport Road, Khajuraho, Madhya Pradesh 471606",
    desc: "Modern 4-star hotel ideal for families and business travelers with premium comfort.",
    img: img3,
    star: "4 Star"
  },
  {
    id: 4,
    name: "Golden Tulip ",
    location: "Opp. Pahil Batika, Main Road, Khajuraho, Madhya Pradesh 471606",
    desc: "Elegant resort-style hotel featuring lush green lawns, pool, and relaxing ambiance.",
    img: img4,
    star: "4 Star"
  },
  {
    id: 5,
    name: "Hotel Chandela",
    location: "Khajuraho Airport Road, Sevagram, Khajuraho, Madhya Pradesh 471606",
    desc: "Heritage luxury hotel known for its royal hospitality and spacious gardens.",
    img: img5,
    star: "4 Star"
  },
  {
    id: 6,
    name: "Clarks Khajuraho",
    location: "Bamitha Road, Near Khajuraho Airport, Khajuraho, Madhya Pradesh 471606",
    desc: "Comfortable 3-star property with modern rooms and excellent dining facilities.",
    img: img7,
    star: "3 Star"
  },
  {
    id: 7,
    name: "Hotel Mint Bundela",
    location: "Airport Road, Khajuraho, Madhya Pradesh 471606",
    desc: "Affordable stay with modern amenities, clean rooms, and a relaxing environment.",
    img: img9,
    star: "3 Star"
  },
  {
    id: 8,
    name: "Hotel Syna Heritage",
    location: "Near PWD Circuit House, Power House Road, Khajuraho, Madhya Pradesh 471606",
    desc: "Traditional architecture blended with modern comfort, offering a peaceful stay.",
    img: img11,
    star: "3 Star"
  }
];
  const totalPages = Math.ceil(hotels.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentHotels = hotels.slice(startIndex, startIndex + itemsPerPage);

  const handleOpenPopup = (name) => {
    setPopupData({ isOpen: true, itemName: name });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo({ top: 300, behavior: 'smooth' });
  };

  return (
    <main className="bg-[#FCFBFA] min-h-screen">
      {/* HERO */}
      <section className="relative h-[50vh] sm:h-[45vh] flex items-start bg-black pt-16 md:pt-24">
        <img src={hotelBg} className="absolute inset-0 w-full h-full object-cover opacity-60" alt="Hotels" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FCFBFA] via-transparent to-transparent" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white/80 hover:text-orange-main transition-colors mb-4 md:mb-6 group"
          >
            <div className="w-6 h-6 md:w-8 md:h-8 rounded-full border border-white/20 flex items-center justify-center group-hover:border-orange-main transition-colors">
              <FaArrowLeft className="text-[8px] md:text-xs" />
            </div>
            <span className="text-[8px] md:text-[10px] font-black uppercase tracking-widest">Go Back</span>
          </motion.button>

          <div className="text-center">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
              <div className="flex items-center justify-center gap-2 md:gap-4 mb-2 md:mb-4">
                <div className="h-[1px] md:h-[2px] w-8 md:w-12 bg-orange-main" />
                <span className="text-orange-main font-black tracking-[0.2em] md:tracking-[0.4em] text-[8px] md:text-[10px] uppercase">Stay with us</span>
                <div className="h-[1px] md:h-[2px] w-8 md:w-12 bg-orange-main" />
              </div>
              <h1 className="text-3xl md:text-5xl font-black text-black uppercase tracking-tight"><span className="text-orange-main">Hotels</span> in Khajuraho Routess</h1>
            </motion.div>
          </div>
        </div>
      </section>

      {/* GRID SECTION */}
      <section className="py-12 lg:py-24">
        <div className="max-w-[1400px] mx-auto px-4 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-8">
            {currentHotels.map((hotel) => (
              <motion.div 
                key={hotel.id}
                whileHover={{ y: -8 }}
                onClick={() => handleOpenPopup(hotel.name)}
                className="group relative h-[300px] sm:h-[380px] lg:h-[420px] rounded-2xl md:rounded-[2.5rem] overflow-hidden cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-white"
              >
                {/* Image */}
                <img 
                  src={hotel.img} 
                  alt={hotel.name} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
                />
                
                {/* Initial Name Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-8 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:opacity-0 transition-opacity duration-300">
                   <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-tight leading-none">{hotel.name}</h3>
                   <div className="flex items-center gap-2 mt-1 md:mt-2 text-gray-300 text-[8px] md:text-[9px] font-bold uppercase tracking-widest">
                     <FaMapMarkerAlt className="text-orange-main" /> {hotel.location}
                   </div>
                </div>

                {/* Hover Detailed Overlay */}
                <div className="absolute inset-0 bg-orange-main/90 flex flex-col justify-center items-center p-6 md:p-8 text-center opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-4 group-hover:translate-y-0">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-xl md:rounded-2xl flex items-center justify-center text-orange-main mb-4 md:mb-6 shadow-xl">
                    <FaHotel size={16} />
                  </div>
                  <h3 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight mb-2 leading-none">{hotel.name}</h3>
                  <div className="flex items-center gap-2 text-white/80 text-[8px] md:text-[10px] font-black uppercase tracking-widest mb-3 md:mb-4">
                    <FaMapMarkerAlt /> {hotel.location}
                  </div>
                  <div className="h-px w-8 md:w-12 bg-white/30 mb-4 md:mb-6" />
                  <p className="text-white text-[10px] md:text-xs font-bold leading-relaxed mb-6 md:mb-8">
                    {hotel.desc}
                  </p>
                  <div className="px-4 py-2 md:px-6 md:py-3 border-2 border-white rounded-full text-white text-[8px] md:text-[10px] font-black uppercase tracking-widest">
                    Book Now
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="mt-16 flex justify-center items-center gap-4">
              <button 
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`flex items-center gap-2 px-6 py-3 rounded-full font-black text-[10px] uppercase tracking-widest transition-all ${
                  currentPage === 1 
                  ? "bg-gray-100 text-gray-300 cursor-not-allowed" 
                  : "bg-white text-orange-main border-2 border-orange-main hover:bg-orange-main hover:text-white shadow-lg"
                }`}
              >
                <FaArrowLeft size={10} /> Previous
              </button>
              
              <div className="flex items-center gap-2">
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => handlePageChange(i + 1)}
                    className={`w-10 h-10 rounded-full font-black text-xs transition-all ${
                      currentPage === i + 1
                      ? "bg-orange-main text-white shadow-xl scale-110"
                      : "bg-white text-gray-400 hover:text-orange-main"
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>

              <button 
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`flex items-center gap-2 px-6 py-3 rounded-full font-black text-[10px] uppercase tracking-widest transition-all ${
                  currentPage === totalPages 
                  ? "bg-gray-100 text-gray-300 cursor-not-allowed" 
                  : "bg-white text-orange-main border-2 border-orange-main hover:bg-orange-main hover:text-white shadow-lg"
                }`}
              >
                Next <FaArrowRight size={10} />
              </button>
            </div>
          )}
        </div>
      </section>

      <CategoryBookingPopup 
        isOpen={popupData.isOpen} 
        onClose={() => setPopupData({ ...popupData, isOpen: false })}
        category="Hotel"
        itemName={popupData.itemName}
      />
    </main>
  );
};

export default Hotels;
